/**
 * ICICI Direct Broker Parser Config
 * 
 * File format: TSV (tab-separated) disguised as .xls
 * Columns: Date, Stock, Action, Qty, Price, Trade Value, Order Ref., Settlement, 
 *          Segment, DP Id - Client DP Id, Exchange, STT, ...
 * 
 * Key characteristics:
 * - Uses 'Stock' column with ICICI-specific symbols (e.g., BHAFOR, AIAENG)
 * - Requires ISIN lookup via broker_symbol_mappings collection
 * - Date format: DD-MMM-YY (e.g., 02-Jan-26)
 * - Action: 'Buy' or 'Sell'
 */

import { Broker } from '@shared/index';
import { BrokerParserConfig } from '../types';

export const iciciDirectConfig: BrokerParserConfig = {
  broker: Broker.ICICI_DIRECT,
  fileType: 'excel',
  fileExtensions: ['.xls', '.xlsx'],
  
  headerConfig: {
    rowIndex: 0,
  },
  
  columns: {
    symbol: 'Stock',
    orderId: 'Order Ref.',
    tradeType: 'Action',
    quantity: 'Qty',
    price: 'Price',
    exchange: 'Exchange',
    timestamp: 'Date',
    
    isinLookup: {
      lookupColumn: 'Stock',
      matchField: {
        NSE: 'symbol',
        BSE: 'symbol',
      },
      exchangeColumn: 'Exchange',
    },
  },
  
  transforms: {
    tradeType: {
      'Buy': 'buy',
      'Sell': 'sell',
    },
    exchange: {
      'NSE': 'NSE',
      'BSE': 'BSE',
    },
    dateFormat: 'DD-MMM-YY',
  },
  
  requiredColumns: ['Date', 'Stock', 'Action', 'Qty', 'Price', 'Order Ref.', 'Exchange'],
};
